export interface ISchedulePreviewContext {
  config?: any;
  assets?: any;
  products?: any;
  contents?: any;
  components?: any;
  location?: any;
  overrides?: any;
  restaurantBridgeData?: any;
}

export interface ISchedulePreviewWithChangeSetContext {
  before: ISchedulePreviewContext;
  after: ISchedulePreviewContext;
}

export interface LocationChannels {
  [channelName: string]: {
    dayparts: LocationChannelsDayparts[];
  };
}

export interface LocationChannelsDayparts {
  name: string;
  defaultAssemblies: IDefaultAssemblies[];
  scheduleItems: LocationChannelsDaypartsScheduleComponents | null;
  globalComponents: {
    [componentType: string]: number;
  };
}

export interface IDefaultAssemblies {
  id: number;
  assemblyId: number;
  startDate: string;
  config: any;
  modifiedAt: string;
}

export interface LocationChannelsDaypartsScheduleComponents {
  screens: ScheduleComponentScreens;
}

export interface ScheduleComponentScreens {
  [channelScreenSequence: number]: {
    sections: ScreenScheduleItem[];
  };
}

export interface ScreenScheduleItem {
  id: number;
  left: number;
  top: number;
  width: number;
  height: number;
  position: number;
  sectionConfig: any;
  componentId: number;
  startDate: string;
  endDate: string | null;
  modifiedAt: string;
  duration: number;
  config: any;
  backups: any[];
}

export enum IPreviewOption {
  BEFORE = 'before',
  AFTER = 'after',
}
